import { Box, Divider, Typography } from "@luce/ui";

interface PackageDetailRowProps {
  label: string;
  value: string;
  divider?: boolean;
}

export function PackageDetailRow({ label, value, divider = true }: PackageDetailRowProps) {
  return (
    <Box className="gap-spacing-md flex flex-col">
      <Box className="gap-spacing-md flex flex-row items-start justify-between">
        <Typography variant="body-sm" color="neutral-foreground-intermediate">
          {label}
        </Typography>
        <Typography
          variant="label-sm"
          color="neutral-foreground-default"
          align="right"
          className="flex-1"
        >
          {value}
        </Typography>
      </Box>
      {divider && <Divider />}
    </Box>
  );
}
